import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

type Props = {
  selectedTemplate: string | undefined;
  documentFile: File | undefined;
  handleChangeTemplate: () => void;
};

const ReplaceTemplateWithDocumentModalFooter: FC<Props> = ({
  selectedTemplate,
  documentFile,
  handleChangeTemplate,
}: Props) => {
  const { t } = useTranslate();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-lg btn-primary"
        onClick={handleChangeTemplate}
        disabled={!selectedTemplate && !documentFile}
      >
        {t('Replace')}
      </button>
    </Modal.Footer>
  );
};

export default ReplaceTemplateWithDocumentModalFooter;
